import React from 'react';
import { Route } from 'react-router-dom';
import BlogSectionPage from '../pages/blog/BlogSectionPage';
import ProtectedRoute from '../components/global/ProtectedRoute';

const blogSectionRoutes = (
    <Route
        path="/blog/section"
        element={
            <ProtectedRoute requiredPermission="settings.blog.view">
                <BlogSectionPage />
            </ProtectedRoute>
        }
    />
);

export default blogSectionRoutes;
